import * as Dialog from '@radix-ui/react-dialog';
import * as React from 'react';

/** Painel lateral acessível (menu mobile). Foco preso, ESC fecha, overlay com token do DS. */
export function Drawer({
  open,
  onOpenChange,
  title,
  children,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="tae-drawer-overlay" />
        <Dialog.Content className="tae-drawer-content" aria-describedby={undefined}>
          <Dialog.Title className="sr-only">{title}</Dialog.Title>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
